// extracted by mini-css-extract-plugin
export default {"container":"NylasErrored_container__oDNJ5","icon":"NylasErrored_icon__k8JOn","title":"NylasErrored_title__QBRRb","subTitle":"NylasErrored_subTitle__AypRX"};